module.exports = __webpack_public_path__ + "static/img/indexICON74.e4c283a8.png";